// extracted by mini-css-extract-plugin
module.exports = {"dataTable":"dataTable__2PVTq","shareholder":"shareholder__1k7iL","mobileDataTable":"mobileDataTable__3QG3o"};